module.exports = __webpack_public_path__ + "img/home.52a4b337.png";